let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8pdE4")).then(() => parcelRequire('lrhH1'));